module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/bullets.7235ce41.svg";